import { render, staticRenderFns } from "./lp-invest-registration.vue?vue&type=template&id=79a9c806&scoped=true"
import script from "./lp-invest-registration.vue?vue&type=script&lang=js"
export * from "./lp-invest-registration.vue?vue&type=script&lang=js"
import style0 from "./lp-invest-registration.vue?vue&type=style&index=0&id=79a9c806&prod&scoped=true&lang=css"
import style1 from "./lp-invest-registration.vue?vue&type=style&index=1&id=79a9c806&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a9c806",
  null
  
)

export default component.exports